import { api } from './config';
import dateFormatMixin from "../mixins/dateFormatMixin";

const consultaService = {

    /**
     * Busca contrato
     * @param ConsultaRequest consultaRequest
     */
    consultaContrato: (consultaRequest, gRecaptchaResponse) => {
        const { cpfCnpjCliente, dataNascimento, numeroContrato, email, telefone  } = consultaService.parseConsultaRequest(consultaRequest)
        const convertedDataNascimento = dateFormatMixin.methods.convertDateBrToUs(dataNascimento)
        const requestParams = `cpfCnpjCliente=${cpfCnpjCliente}&dataNascimento=${convertedDataNascimento}&numeroContrato=${numeroContrato}&email=${email}&telefone=${telefone}`
        return api.get(`/publicoalvo/buscarContrato?${requestParams}`, {
            headers: {
                'g-recaptcha-response': gRecaptchaResponse
            }
        })
    },

    /**
     * Busca contrato
     * @param ConsultaRequest consultaRequest
     */
    simular: (prazoCarencia, chave) => {
        const requestParams = `prazoCarencia=${prazoCarencia}`
        return api.get(`/publicoalvo/simulacao?${requestParams}`, {
            headers: {
                'g-recaptcha-response': chave
            }
        })
    },
    /**
     *
     * @param {ConsultaRequest} consultaRequest
     * @returns {ConsultaRequest}
     */
    parseConsultaRequest(consultaRequest) {
        let parsedRequest = consultaRequest
        parsedRequest.telefone = parsedRequest.telefone.replace(/\D+/g, '');
        return parsedRequest
    }
}

export default consultaService
